import { Injectable } from '@angular/core';
import Dexie, { Table } from 'dexie';

export interface CryptoKeyRecord {
  userId: number;
  key: CryptoKey;
}

@Injectable({ providedIn: 'root' })
export class KeyStoreService extends Dexie {
  keys!: Table<CryptoKeyRecord, number>;

  constructor() {
    super('crypto-key-store');
    this.version(1).stores({
      keys: 'userId',
    });
  }

  async getKey(userId: number): Promise<CryptoKey | null> {
    const record = await this.keys.get(userId);
    return record ? record.key : null;
  }

  async saveKey(userId: number, key: CryptoKey): Promise<void> {
    await this.keys.put({ userId, key });
  }

  async deleteKey(userId: number): Promise<void> {
    await this.keys.delete(userId);
  }
}
